import { NeighborhoodMatchProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  NeighborhoodMatchProps["options"],
  OptionalPropertyOf<NeighborhoodMatchProps["options"]>
> = {
  hideAttribution: false,
};

export default defaultState;
